import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Test Run icon. Exported from Figma (Bombiix 2026). */
const TestRunIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M6.66699 13.9586V6.04087C6.66699 4.93463 7.93645 4.30955 8.81327 4.98403L13.9598 8.94288C14.6536 9.47661 14.6536 10.5228 13.9598 11.0565L8.81327 15.0154C7.93645 15.6899 6.66699 15.0648 6.66699 13.9586Z"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);

export default TestRunIcon;
